<template>
  <el-dialog v-model="visible" class="login" align-center @close="close">
    <div class="box">
      <div class="header">
        <template v-if="!status.binding">
          <img
            :src="
              status.scan ? '@/baidupteAssets/icon/sjhmdl.png' : '@/baidupteAssets/icon/wxsmdl.png'
            "
            alt=""
            style="position: relative; right: -16px"
          />
          <div class="mask"></div>
          <img
            :src="status.scan ? '/background/shoujidl.png' : '/background/erweima.png'"
            alt=""
            style="cursor: pointer"
            @click="handoff"
          />
        </template>
      </div>
      <div v-if="status.scan && !status.binding">
        <div class="mode">
          <div :active="status.mode === 1" @click="change(1)">
            <img src="@/baidupteAssets/icon/ytptea.png" alt="" />
            <span>羊驼PTE</span>
            <div class="top"></div>
          </div>
          <div :active="status.mode === 2" @click="change(2)">
            <img src="@/baidupteAssets/icon/wxa.png" alt="" />
            <span>微信</span>
            <div class="top"></div>
          </div>
        </div>
        <template v-if="status.mode === 1">
          <div class="QRcode">
            <div class="QRcode-box" style="padding: 12px">
              <div ref="qrcode"></div>
            </div>
            <img class="icon" src="@/baidupteAssets/image/ytptesm.png" alt="" />
          </div>
          <div class="tips">打开羊驼PTEAPP点击首页右上角“扫一扫”</div>
        </template>
        <template v-else>
          <div class="QRcode">
            <div class="QRcode-box">
              <div class="loading" :loading="status.loading">
                <el-icon class="is-loading" :size="48" color="var(--el-color-primary)">
                  <Loading />
                </el-icon>
              </div>
              <img v-if="status.qrcode" :src="status.qrcode" width="164px" height="164px" alt="" />
            </div>
            <img class="icon" src="@/baidupteAssets/image/wxsys.png" alt="" />
          </div>
          <div class="tips">打开微信使用扫一扫</div>
        </template>
      </div>
      <div class="form-box" v-else>
        <div style="text-align: center; font-size: 22px; font-weight: bold; margin-bottom: 22px">
          {{ status.binding ? '绑定手机号' : '手机验证码登录' }}
        </div>
        <el-form ref="form" :rules="rules" :model="formData" label-width="0" size="large">
          <el-form-item prop="phone" style="margin-bottom: 10px" :show-message="false">
            <el-input v-model="formData.phone" placeholder="请输入手机号">
              <template #prefix>
                <el-dropdown trigger="click" max-height="300px" @command="select">
                  <div style="display: flex; align-items: center">
                    <span style="line-height: 0; min-width: 36px">+{{ formData.phonecode }}</span>
                    <el-icon style="margin-left: 2px">
                      <CaretBottom />
                    </el-icon>
                  </div>
                  <template #dropdown>
                    <el-dropdown-menu style="padding: 2px 0">
                      <el-dropdown-item v-for="item in options" :command="item.phonecode"
                        >+{{ item.phonecode }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div style="display: flex">
              <el-input v-model="formData.code" placeholder="请输入验证码" />
              <el-button style="margin-left: 10px" @click="send" :disabled="status.disabled">{{
                status.disabled ? `${status.second}秒后重试` : '获取验证码'
              }}</el-button>
            </div>
          </el-form-item>
          <el-form-item style="margin: 0">
            <div class="button" @click="submit">
              {{ status.binding ? '绑定' : '登录/注册' }}
            </div>
          </el-form-item>
          <el-form-item>
            <span
              style="color: var(--el-color-primary); cursor: pointer"
              @click="status.show = true"
              >无法获取验证码？</span
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="agreement-box">
        <span @click="setAgreement" :class="{ active: agreement }" class="radio"></span>
        <p class="text">
          我已阅读并且同意<a
            href="https://www.ytaxx.com/userAgreement-pteweb.html"
            target="_blank"
            rel="noopener noreferrer"
            >《羊驼PTE用户协议》</a
          >
          和
          <a
            href="https://www.yangtuoedu.com/privacy-policy/?appType=1&review=0"
            target="_blank"
            rel="noopener noreferrer"
            >《隐私政策》</a
          >
        </p>
      </div>
    </div>
    <el-dialog v-model="status.show" class="tips-dialog" width="500" align-center>
      <img src="@/baidupteAssets/image/wfhqyzm.png" width="100%" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script setup lang="ts">
import {
  ElDialog,
  ElInput,
  ElButton,
  ElFormItem,
  ElForm,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElIcon,
  ElMessage
} from 'element-plus'
import { CaretBottom, Loading } from '@element-plus/icons-vue'
import { http } from '@/utils'
import { ref, reactive, nextTick } from 'vue'
import { md5 } from 'js-md5'

// @ts-ignore
import QRCode from 'qrcodejs2-fix'

const rules = {
  phone: { required: true, message: '', trigger: 'blur' },
  code: { required: true, message: '请输入验证码', trigger: 'blur' }
}

const status = reactive({
  scan: false,
  binding: false,
  mode: 2,
  loading: true,
  qrcode: undefined,
  sceneId: undefined,
  uuid: '',
  disabled: false,
  show: false,
  second: 60
})
const agreement = ref(false)
const setAgreement = () => {
  agreement.value = !agreement.value
}
let countdown: any
let tick: any
const visible = ref(true)
const qrcode = ref()
const form = ref()
const options = reactive<any>([])
const formData = reactive<{
  phone?: string
  code?: string
  phonecode: number
  userCode?: string
}>({
  phonecode: 86
})

const clearCountdown = () => {
  status.second = 60
  status.disabled = false
  clearInterval(countdown)
}
declare global {
  interface Window {
    returnCitySN: {
      cip: string
    }
  }
}

function setAuthHeaders(param: { ts: number; phone: string }) {
  return {
    userAgent: navigator.userAgent,
    ts: param.ts,
    expire: 300,
    netIp: window.returnCitySN.cip as string,
    clientType: 'pcweb',
    phone: param.phone
  }
}
function sortASCII(obj: { [x: string]: any }, isSort = true) {
  let arr: string[] = []
  Object.keys(obj).forEach((item) => arr.push(item))
  let sortArr = isSort ? arr.sort() : arr.sort().reverse()
  let sortObj: { [key: string]: string } = {}
  for (let i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]]
  }
  return sortObj
}
function setMD5Accsii(Headers: any) {
  const payload = sortASCII(Headers)
  let payloadStr = ''
  Object.keys(payload).forEach((K) => {
    payloadStr += `${K}=${payload[K]}&`
  })
  payloadStr += 'key=yangtuoedu'
  return md5(payloadStr)
}

const send = () => {
  form.value.validateField('phone').then((valid: any) => {
    if (valid) {
      const header = setAuthHeaders({
        phone: formData.phone as string,
        ts: Date.now()
      })
      const sign = setMD5Accsii(header).toUpperCase()
      status.disabled = true
      countdown = setInterval(() => (status.second ? status.second-- : clearCountdown()), 1000)
      http
        .post(
          '/api/message/sendSms',
          {
            ...formData,
            sign
          },
          {
            headers: header as any
          }
        )
        .catch(clearCountdown)
    }
  })
}

const handoff = () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  status.scan = !status.scan
  clearInterval(tick)
  if (status.scan) load()
}

const change = (val: number) => {
  if (val === status.mode) return
  status.mode = val
  clearInterval(tick)
  load()
}

const load = () => {
  if (status.mode === 1) {
    status.uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
    nextTick(
      () =>
        new QRCode(qrcode.value, {
          text: JSON.stringify('logincode=' + status.uuid),
          width: 140,
          height: 140
        })
    )
    tick = setInterval(polling, 1000)
  } else {
    status.loading = true
    http
      .post('/api/auth/callBack')
      .then((res) => {
        status.qrcode = res.data.url
        status.sceneId = res.data.sceneId
        tick = setInterval(polling, 1000)
      })
      .finally(() => (status.loading = false))
  }
}

const polling = () => {
  if (status.mode === 1)
    http.get('/api/user/giveTokenByUUID', { uuid: status.uuid }, { skipMsg: true }).then((res) => {
      if (!res.data) return
      localStorage.setItem('token', res.data)
      location.reload()
      visible.value = false
    })
  else
    http
      .get('/api/auth/verifySceneId', { sceneId: status.sceneId }, { skipMsg: true })
      .then((res) => {
        localStorage.setItem('token', res.data.token)
        location.reload()
        visible.value = false
      })
      .catch((err) => {
        if (err.code === 2) return
        else if (err.code === 1011) {
          clearInterval(tick)
          formData.userCode = err.msg
          status.binding = true
        } else ElMessage.error(err.msg)
      })
}

const submit = () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  form.value.validate().then((valid: any) => {
    if (valid)
      http
        .post(status.binding ? '/api/auth/bindingPhone' : '/api/auth/loginPhone', formData)
        .then((res) => {
          localStorage.setItem('token', res.data.token)
          location.reload()
          visible.value = false
        })
  })
}

http.post('api/message/countryList').then((res) => {
  options.push(...res.data)
})

const select = (val: number) => (formData.phonecode = val)

const close = () => {
  clearInterval(tick)
  clearInterval(countdown)
}
</script>

<style lang="scss">
.tips-dialog {
  padding: 0 !important;
  border-radius: 30px !important;
}

.login {
  width: 440px !important;
  padding: 0 !important;
  border-radius: 30px !important;

  .el-dialog__header {
    padding-top: 0 !important;
  }

  .el-dialog__body {
    overflow: hidden;
    border-radius: 30px;
  }
}
</style>

<style lang="scss" scoped>
.box {
  padding-bottom: 60px;

  .header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    height: 84px;

    .mask {
      position: absolute;
      right: 0;
      width: 83px;
      height: 100%;
      z-index: 1;
      clip-path: polygon(100% 100%, 0% 100%, 0 0%, 0 0);
    }
  }
  .form-box {
    padding: 0 64px;
  }

  .mode {
    display: flex;
    margin-top: -6px;
    justify-content: center;

    > div {
      margin: 0 42px;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    > div[active='false'] {
      opacity: 0.3;
      filter: grayscale(1);

      .top {
        display: none;
      }
    }

    .top {
      width: 0;
      height: 0;
      border-left: 12px solid transparent;
      border-right: 12px solid transparent;
      border-bottom: 16px solid #f8f7fc;
      margin-top: 4px;
    }
  }

  .QRcode {
    background: #f8f7fc;
    border-radius: 19px;
    margin: 0px 32px;
    padding: 16px 20px;
    display: flex;
    gap: 0 25px;

    .QRcode-box {
      width: 164px;
      height: 164px;
      background-color: #fff;
      position: relative;
      flex: none;
      :deep(img) {
        width: 100%;
        height: 100%;
      }
      .loading {
        position: absolute;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: rgba(255, 255, 255, 1);
        opacity: 0;
        transition: opacity 0.5s;
      }

      .loading[loading='true'] {
        opacity: 1;
      }
    }
    .icon {
      flex: 1;
      width: 120px;
    }
  }

  .tips {
    margin-top: 10px;
    text-align: center;
  }

  .phonecode {
    :deep(.el-select__icon) {
      margin: 0;
    }

    :deep(.el-input__validateIcon) {
      display: none;
    }
  }

  .button {
    width: 100%;
    text-align: center;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(
      90deg,
      var(--el-color-primary-light-3) 0%,
      var(--el-color-primary) 100%
    );
    border: none;
    border-radius: 10px;
  }

  .agreement-box {
    margin-top: 15px;
    padding: 0 64px;
    font-size: var(--el-font-size-base);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0 6px;
    color: var(--el-text-color-content);

    .radio {
      position: relative;
      cursor: pointer;
      display: block;
      width: 16px;
      height: 16px;
      margin-top: 5px;
      background-image: url(@/assets/images/icon/wxz@2x.png);
      background-size: 100% 100%;
      &.active {
        background-image: url(@/assets/images/icon/xz@2x.png);
      }
    }
    .text {
      font-size: var(--el-font-size-base);
      line-height: 1.5;
      vertical-align: text-top;
      flex: 1;
      a {
        color: var(--el-color-primary);
      }
    }
  }
}
</style>
<style lang="scss">
.login {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__headerbtn {
    width: 32px;
    height: 32px;
    right: -32px;
    top: -16px;

    .el-dialog__close {
      color: #fff;
      font-size: var(--el-font-size-extra-large);
    }
  }
}
</style>
